<template>
  <div class="b-test purchase__testimonials">
    <div>
      <stars :value="rating" />

      <span class="h6 text-secondary mb-0">
        {{ rating }}
      </span>
    </div>

    <a
      v-if="hasBlock"
      href="#testimonials"
      class="link-cta"
      @click.prevent="goTo('testimonials')"
    >
      <span>{{
        $t('testimonial.see', {
          number: numberOf,
        })
      }}</span>
    </a>

    <span v-else class="link-cta">
      {{
        $t('testimonial.based_on_number', {
          number: numberOf,
        })
      }}
    </span>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import Stars from '@/components/stars/Stars.vue'

export default {
  name: 'PurchaseTestimonials',
  components: {
    Stars,
  },
  props: {
    rating: { type: Number, required: true },
    numberOf: { type: Number, required: true },
    hasBlock: { type: Boolean, default: false },
  },
  methods: {
    ...mapMutations({
      setScroll: 'behavior/SET_SCROLL',
    }),
    goTo(id) {
      const testimonialSlice = document.getElementById(id)

      if (testimonialSlice) {
        this.setScroll(true)
        testimonialSlice.parentElement.scrollIntoView()
        this.setScroll(false)
        this.$track.click('see_testimonials')
      }
    },
  },
}
</script>

<style lang="scss">
.purchase__testimonials {
  display: flex;
  justify-content: center;
  align-items: center;

  .link-cta {
    text-align: left;
  }

  span.link-cta {
    cursor: default;
    position: relative;
    top: rem(1px);
  }

  > div {
    display: flex;
    align-items: center;
    margin-right: var(--spacing);
    justify-content: flex-end;

    .stars {
      margin-right: rem(5px);
    }
  }
}
</style>
